
import React from 'react';

interface Product {
  id: string;
  name: string;
  tags: string[];
  longDescription: string;
  pricing: string;
}

interface ProductInfoProps {
  product: Product;
}

export default function ProductInfo({ product }: ProductInfoProps) {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div className="lg:col-span-2">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              About This Product
            </h2>
            <p className="text-gray-600 leading-relaxed text-base mb-8">
              {product.longDescription}
            </p>

            <div className="flex flex-wrap gap-2">
              {product.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-4 py-1.5 bg-gray-100 text-gray-600 text-sm font-medium rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-1">
            <div className="bg-gray-50 rounded-xl p-8 border border-gray-100 sticky top-28">
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                Get Started Today
              </h3>
              <p className="text-sm text-gray-500 mb-6">
                Plans starting at an affordable price
              </p>

              <div className="text-3xl font-extrabold text-teal-600 mb-6">
                {product.pricing}
              </div>

              <a
                href="#"
                className="flex items-center justify-center gap-2 w-full py-3.5 bg-teal-500 text-white font-bold rounded-lg hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap mb-4"
                onClick={(e) => {
                  // Prevent default navigation for demo purposes
                  e.preventDefault();
                }}
              >
                Visit Website
                <i className="ri-external-link-line"></i>
              </a>

              <div className="space-y-3 mt-6 pt-6 border-t border-gray-200">
                <div className="flex items-center gap-3 text-sm text-gray-600">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-shield-check-line text-teal-500"></i>
                  </div>
                  Money-back guarantee
                </div>
                <div className="flex items-center gap-3 text-sm text-gray-600">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-customer-service-2-line text-teal-500"></i>
                  </div>
                  24/7 customer support
                </div>
                <div className="flex items-center gap-3 text-sm text-gray-600">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-lock-line text-teal-500"></i>
                  </div>
                  Secure and trusted platform
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
